module.exports = __webpack_public_path__ + "static/media/bg8.eabf1d19.jpg";